import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../data";
import { ChevronDown } from "lucide-react";

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen overflow-hidden noise-overlay" data-testid="hero-section">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Baleia jubarte saltando em Abrolhos" className="w-full h-full object-cover" />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(4,11,22,0.55) 0%, rgba(4,11,22,0.25) 35%, rgba(4,11,22,0.85) 92%)",
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-40 pb-24 min-h-screen flex flex-col justify-between">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="overline mb-6">Living Aboard · Caravelas — Bahia</div>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-light leading-[0.95] tracking-tight">
            Abrolhos
            <span className="block" style={{ color: "var(--ocean-accent)" }}>2026 · 2027.</span>
          </h1>
          <p className="mt-6 text-base md:text-lg font-light max-w-xl" style={{ color: "var(--ocean-muted)" }}>
            Quatro dias entre baleias jubarte, naufrágios e chapeirões. A bordo do catamarã ZEUS,
            no único parque marinho do Atlântico Sul que ainda surpreende mergulhadores experientes.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a href="#pacotes" className="btn-primary" data-testid="hero-pacotes-btn">
              Ver pacotes
            </a>
            <a href="#agenda" className="btn-ghost" data-testid="hero-reservar-btn">
              Reservar agora
            </a>
          </div>
        </motion.div>

        {/* bottom strip */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 1 }}
          className="hidden md:grid grid-cols-4 gap-12 pt-12"
        >
          {[
            ["11", "Hóspedes a bordo"],
            ["04", "Cabines · 2 suítes"],
            ["11", "Mergulhos / 4 dias"],
            ["50'", "Catamarã ZEUS"],
          ].map(([num, label]) => (
            <div key={label} className="border-t pt-4" style={{ borderColor: "rgba(255,255,255,0.18)" }}>
              <div className="font-display text-4xl md:text-5xl font-light">{num}</div>
              <div className="overline mt-2" style={{ color: "var(--ocean-muted)" }}>
                {label}
              </div>
            </div>
          ))}
        </motion.div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center" style={{ color: "var(--ocean-muted)" }}>
          <ChevronDown className="animate-bounce" size={20} />
        </div>
      </div>
    </section>
  );
};

export default Hero;